<div
  class="dropdown emoji-btn is-right is-up"
  [ngClass]="{ 'is-active': emojiToggle }"
  (click)="toggleEmoji()"
>
  <!-- <span [innerHTML]="':blush:' | emojis"></span> -->
  <span
    ><i class="fa fa-smile-o has-text-info mar-t-5" aria-hidden="true"></i
  ></span>
  <div class="dropdown-menu">
    <div class="dropdown-content">
      <div class="dropdown-item">
        @for (emoji of emojisList; track emoji) {
        <span
          class="icon-emoji"
          (click)="appendEmojiText($event, emoji); (false)"
        >
          <span [innerHTML]="':' + emoji + ':' | emojis"></span>
        </span>
        }
      </div>
    </div>
  </div>
</div>
